import { AfterContentChecked, AfterContentInit, Directive, ElementRef, inject } from '@angular/core';
import { Panel as PanelService } from '../panel.svc';

/**
 * @description This directive is meant to be attached to the `<header />`
 *   element of the OkePanel. It is the first immediate child of the OkePanel
 *   component (host element). This directive adds the appropriate className
 *   and marks the Component state's `header` property as `projected`.
 */
@Directive({
  selector: '[okePanelHeader]'
})
export class Header implements AfterContentInit, AfterContentChecked {
  private readonly _panelSvc: PanelService = inject(PanelService, {
    host: true
  });
  private readonly _elem: ElementRef = inject(ElementRef);

  constructor() {
    this._elem.nativeElement.classList.add('header');
  }

  ngAfterContentInit(): void {
    if (!this._elem) {
      return;
    }
    this._panelSvc.updateState('header', {
      projected: true
    });
  }

  ngAfterContentChecked(): void {
    if (!(this._elem && !this._panelSvc.$state().header.projected)) {
      return;
    }
    this._panelSvc.updateState('header', {
      projected: true
    });
  }
}
